import { useTranslation } from "react-i18next";
import { LeftSocialMediaIconUI } from "./LeftSocialMediaIconUI";
import { RenderNavItem } from "./RenderNavItem";
import { headerHeight } from "../utils/constants";

export const CommonPageUiLayer = ({
  leftNavsList,
  imgSrc = "assets/img/inner-bg2.png",
  isLeftNavsListLong = false,
  children,
}) => {
  const { t } = useTranslation();

  return (
    <>
      <section id="hero" className="hero hero2">
        <LeftSocialMediaIconUI />

        <div className="carousel-item active">
          <img src={imgSrc} className="img-fluid" alt="alt" />
        </div>
      </section>
      {/* End Slider */}
      <section className="section inner-pad1">
        <div className="container ">
          <div className="row">
            <div className="col-lg-3">
              <div
                className={`site-menu ${isLeftNavsListLong ? "min-height-400" : ""}`}
              >
                <nav className="sidebar card py-2">
                  <ul className="nav flex-column" id="nav_accordion">
                    {leftNavsList.map((item, index) => (
                      <RenderNavItem item={item} index={index} t={t} />
                    ))}
                  </ul>
                </nav>
              </div>
            </div>
            <div
              className="col-lg-9"
              style={{ minHeight: `calc(100vh - ${headerHeight + 53}px)` }}
            >
              {children}
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
